<script>
   import { onMount } from "svelte";
    let loading = false
    export let params;
    const apiUrl = 'https://jsonplaceholder.typicode.com/posts/'
    let data = []

    onMount(async () => {
      const response = await fetch(apiUrl + params.id)
      data = await response.json()
      console.log(response)
      loading = response.ok
    })

</script>

{#if loading}
<h1>{data.title}</h1>
<p>{data.body}</p>
{/if}